import React from "react";
import { LegalLayout } from "./LegalLayout";
import { COMPANY } from "@/lib/company";

export default function Teslimat() {
  return (
    <LegalLayout title="Teslimat ve Kargo Koşulları">
      <p>
        {COMPANY.brand} bir <strong>dijital hizmettir (SaaS – yazılım aboneliği)</strong>. Fiziksel bir
        ürün gönderimi bulunmadığından kargo süreci ve kargo ücreti yoktur.
      </p>

      <h2>Teslimat Şekli ve Süresi</h2>
      <ul>
        <li>Abonelik satın alma / plan seçimi işleminiz onaylandığı anda hizmet <strong>anında</strong> aktif hâle gelir.</li>
        <li>Hizmete, kayıt olduğunuz e-posta ve şifre ile <a href={COMPANY.website}>{COMPANY.websiteLabel}</a> üzerindeki işletme panelinizden anında erişebilirsiniz.</li>
        <li>Herhangi bir fiziksel teslimat, kargo firması veya teslimat adresi söz konusu değildir.</li>
      </ul>

      <h2>Hizmete Erişememe Durumu</h2>
      <p>
        Ödemeniz alındığı hâlde hizmete erişemiyorsanız, lütfen {COMPANY.phone} numaralı telefondan veya{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresinden bizimle iletişime geçin. Sorununuz
        en kısa sürede giderilir.
      </p>

      <h2>Satıcı Bilgileri</h2>
      <p>{COMPANY.legalName} · {COMPANY.address} · Tel: {COMPANY.phone}</p>
    </LegalLayout>
  );
}
